import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { VehicleRoadTaxStatusEnum } from '../enums/vehicle-road-tax-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function vehicleRoadTaxStatusToColor(
	status: VehicleRoadTaxStatusEnum,
): string {
	switch (status) {
		case VehicleRoadTaxStatusEnum.PENDING:
			return RecordColorEnum.AMBER;

		case VehicleRoadTaxStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case VehicleRoadTaxStatusEnum.EXPIRED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
